// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/table/timeline/Timeline";
import { updateView } from "actions/table";
import { updateRangeAndFetch } from "actions/events/thunks";
import { updateTimelineWindow } from "actions/timeline";
import { newWindowRange } from "components/plannings/table/timeline/utils/processors";
import { DEFAULT_COLOR, DEFAULT_LIGHT_COLOR, darken } from "utils/colors";
import { processEvents, generateRows } from "./processors";

const getStyle = (color) => `background:${color};border: 1px solid ${darken(color)};`;

// Component formatting
export const format = (isLight, byId, item) => {
  const { id, presetId, group, name, start, end } = item;

  const preset = byId[presetId];
  const color = isLight ? DEFAULT_LIGHT_COLOR : preset.color || DEFAULT_COLOR;

  return {
    id,
    group,
    event: item,
    content: name,
    style: getStyle(color),
    start: new Date(start),
    end: new Date(end),
  };
};

const mapStateToProps = ({
  events: { events, rows },
  presets: { byId, isLight },
  resources: { courseIndex, groupIndex, peopleIndex, roomIndex },
  ux: { isSmall, language },
  table: { dateStart, dateEnd, focus, updatedFromPicker },
  timeline: { start, end },
}) => {
  const [focusStart, focusEnd] = newWindowRange("FOCUS", focus);
  const defaultStart = start || focusStart;
  const defaultEnd = end || focusEnd;
  const boundFormat = format.bind(null, isLight, byId);

  return {
    dateStart,
    dateEnd,
    defaultEnd,
    defaultStart,
    focus,
    isSmall,
    items: processEvents(events).map(boundFormat),
    language,
    rows: generateRows({ courseIndex, groupIndex, peopleIndex, roomIndex }, rows),
    updatedFromPicker,
  };
};

const mapDispatchToProps = {
  updateRangeAndFetch,
  updateView,
  updateTimelineWindow,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
